module.exports = __webpack_public_path__ + "images/265f1dd.jpg";